import ProductAddons from './product-addons-controller'

export default ProductAddons
